import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[appTimeMask]'
})
export class TimeMaskDirective {

    constructor(private el: ElementRef) { }

    @HostListener('input', ['$event'])
    onInput(event: any): void {
        const input = event.target;
        const previousValue = input.value;
        let value = previousValue.replace(/\D/g, ''); // Solo números

        if (value.length > 6) value = value.substring(0, 6);

        let formatted = '';
        if (value.length > 0) {
            formatted = value.substring(0, 2);
            if (value.length > 2) {
                formatted += ':' + value.substring(2, 4);
                if (value.length > 4) {
                    formatted += ':' + value.substring(4, 6);
                }
            }
        }

        if (previousValue !== formatted) {
            const selectionStart = input.selectionStart;

            const colonsBefore = (previousValue.substring(0, selectionStart).match(/:/g) || []).length;
            const colonsAfter = (formatted.substring(0, selectionStart).match(/:/g) || []).length;
            const addedColons = colonsAfter - colonsBefore;

            input.value = formatted;

            const newPosition = selectionStart + addedColons;
            input.setSelectionRange(newPosition, newPosition);

            input.dispatchEvent(new Event('input'));
        }
    }
}
